/**
 * WorkOS inbound presenter.
 */
import type { InboundProviderPresenter } from '@/lib/integrations/inbound/types'

import {
  WORKOS_EVENT_CATEGORIES,
  WORKOS_EVENT_METADATA,
} from './supported-events'

export const WORKOS_SIGNING_SECRET_MIN_LENGTH = 16

export const workosInboundPresenter: InboundProviderPresenter = {
  providerId: 'workos',
  displayName: 'WorkOS',
  categories: WORKOS_EVENT_CATEGORIES,
  events: WORKOS_EVENT_METADATA,
  defaultTriggerLoop: true,
  triggerEventId({ orgId, brandId, eventType }) {
    return `workos:${orgId}:${brandId}:${eventType}`
  },
}
